import { AmtAdapter } from "./AmtAdapter";

import { ColumnDefinition } from "../../model/ColumnDefinition";

import { ICcyLookupService } from "../../lookup/model/ICcyLookupService";

export class UsdAmtAdapter extends AmtAdapter {
  constructor(ccyPairLookup: ICcyLookupService) {
    super(ccyPairLookup);
  }

  getCcyCode(order: any): string {
    return "USD";
  }
}
